import { common } from '../common-filter-data'
import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_TIME_FILTERS,
  RESET_TIME_FILTERS,
} from '../../../actions/actionTypes'

export const timeFilter = (state = [], action) => {
  const { type, payload = {}, entity, sliceRefId, sbsParams } = action
  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      return (
        (payload.TIME && payload.TIME.map(slice => ({ ...slice }))) || state
      )

    case SET_CURRENT_FILTER_INFO:
      return payload.timeFilter.map(slice => ({ ...slice }))

    case RESET_TIME_FILTERS:
      const TIME = common.DEFAULTS && common.DEFAULTS.DEFAULT_TIME
      if (entity === 'duration') {
        // replace duration only
        return state.map((slice, index) => ({
          ...slice,
          inputDurationValue: TIME[index].sliceDurationMax,
        }))
      }
      // replace all but duration
      // resetTimeFilterParams(TIME.length);
      return TIME.map((slice, index) => ({
        ...slice,
        inputDurationValue: state[index].inputDurationValue,
      }))

    case UPDATE_TIME_FILTERS:
      /**
       * This reducer is duplicated in filterInfo.js, where it updates the state used for search req.
       * Here, it updates the state used for the UI after time filter applied.
       */
      if (!state.length) {
        return state
      }

      if (entity === 'duration') {
        const newDuration = Math.round(payload.duration)
        return state.map((slice = {}) => ({
          ...slice,
          inputDurationValue: newDuration,
        }))
      }
      const { min, max } = payload
      const timeType = entity === 'arrive' ? 'LandingTime' : 'TakeoffTime'

      if (sbsParams.isSBS) {
        return state.map(slice => {
          slice[`min${timeType}`] = min
          slice[`max${timeType}`] = max
          return slice
        })
      }
      return state.map((slice, index) => {
        if (sliceRefId - 1 === index) {
          slice[`min${timeType}`] = min
          slice[`max${timeType}`] = max
        }
        return slice
      })

    default:
      return state
  }
}
